import { makeVar } from '@apollo/client';

export const partnerInfoVar = makeVar({});
export const meVar = makeVar({});

export const globalErrorMessageVar = makeVar({});

export const challengeTabsState = makeVar({});
